import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=799336a1"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799336a1')) {
      api.createRecord('799336a1', component.options)
    } else {
      api.reload('799336a1', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=799336a1", function () {
      api.rerender('799336a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/point_manage/point_rule/components/basic_info.vue"
export default component.exports